import { FC, Fragment, useCallback } from "react";
import { Button, Stack, Typography } from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { useDialog } from "../../../../../../utils/hooks/useDialog.hook";
import { FilterTemplatesDialog } from "../templates-table/FilterTemplatesDialog";

interface FilterTemplateDropdownHeaderProps {
  onClose(): void;
}
export const FilterTemplateDropdownHeader: FC<
  FilterTemplateDropdownHeaderProps
> = ({ onClose }) => {
  const {
    open: openFilterTemplate,
    openDialog: openFilterTemplateDialog,
    closeDialog: closeFilterTemplateDialog,
  } = useDialog();

  const dialogCloseHandler = useCallback(() => {
    closeFilterTemplateDialog();
    onClose();
  }, [onClose, closeFilterTemplateDialog]);

  const filterTemplateClickHandler = useCallback(() => {
    openFilterTemplateDialog();
  }, [openFilterTemplateDialog]);

  return (
    <Fragment>
      <Stack
        direction="row"
        justifyContent="space-between"
        py={1}
        pl={1.5}
        pr={1}
        alignItems="center"
      >
        <Typography variant="subtitle2">Filter Templates</Typography>
        <Button
          variant="text"
          startIcon={<SettingsOutlinedIcon />}
          size="small"
          onClick={filterTemplateClickHandler}
        >
          Manage Templates
        </Button>
      </Stack>
      <FilterTemplatesDialog
        onClose={closeFilterTemplateDialog}
        onApplyCallback={dialogCloseHandler}
        open={openFilterTemplate}
      />
    </Fragment>
  );
};
